import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'
import { getDestinations, addDestination, removeDestination, editDestination, assignHotelToDestination, assignAerolineToDestination, assignOperatorToDestination, removeHotelFromDestination, removeAerolineFromDestination, removeOperatorFromDestination } from './thunks'
import { formatPlaceAerolineToObject, formatPlaceHotelToObject, formatPlaceOperatorToObject, formatPlaceWithAerolineAndHotelToObject } from '../../util/util'


const initialState = {
  destinations: [],
  error: null,
  status: 'idle',
  lastFetched: null,
}

export const destinationSlice = createSlice({
  name: 'destinations',
  initialState,
  reducers: {
    resetDestinationStatus: (state) => { state.status = 'idle'; state.lastFetched = null; },
  },
  extraReducers: (builder) => {

    builder.addCase(getDestinations.pending, (state, action) => {
      state.status = 'loading'
    })

    builder.addCase(getDestinations.fulfilled, (state, action) => {
      state.destinations = (action.payload || []).map(e => formatPlaceWithAerolineAndHotelToObject(e))
      state.status = 'successful'
      state.lastFetched = Date.now()
    })

    builder.addCase(getDestinations.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error
    })

    builder.addCase(addDestination.fulfilled, (state, action) => {
      state.destinations.push(formatPlaceWithAerolineAndHotelToObject(action.payload))
    })

    builder.addCase(removeDestination.fulfilled, (state, action) => {
      state.destinations = state.destinations.filter(e => e.id !== action.payload)
    })

    builder.addCase(editDestination.fulfilled, (state, action) => {
      const payload = action.payload
      state.destinations = state.destinations.map(e => e.id === payload.id ? formatPlaceWithAerolineAndHotelToObject(payload) : e)
    })

    builder.addCase(assignHotelToDestination.fulfilled, (state, action) => {

      const { id, items } = action.payload
      const hotelsFormatted = items.map(e => formatPlaceHotelToObject(e))
      state.destinations = state.destinations.map(destination => {
        if (destination.id === id) {
          return {
            ...destination,
            hotels: [...destination.hotels, ...hotelsFormatted]
          }
        }

        return destination
      })
    })
    builder.addCase(assignAerolineToDestination.fulfilled, (state, action) => {

      const { id, items } = action.payload
      const aerolinesFormatted = items.map(e => formatPlaceAerolineToObject(e))

      state.destinations = state.destinations.map(destination => {
        if (destination.id === id) {
          return {
            ...destination,
            aerolines: [...destination.aerolines, ...aerolinesFormatted]
          }
        }

        return destination
      })
    })
    builder.addCase(removeHotelFromDestination.fulfilled, (state, action) => {
      const { destinationId, id } = action.payload
      state.destinations = state.destinations.map(destination => {
        if (destination.id === destinationId) {
          return {
            ...destination,
            hotels: destination.hotels.filter(e => e.id !== id)
          }
        }

        return destination
      })

    })
    builder.addCase(removeAerolineFromDestination.fulfilled, (state, action) => {
      const { destinationId, id } = action.payload
      state.destinations = state.destinations.map(destination => {
        if (destination.id === destinationId) {
          return {
            ...destination,
            aerolines: destination.aerolines.filter(e => e.id !== id)
          }
        }
        return destination
      })
    })
    builder.addCase(assignOperatorToDestination.fulfilled, (state, action) => {
      const { id, items } = action.payload
      const operatorsFormatted = items.map(e => formatPlaceOperatorToObject(e))

      state.destinations = state.destinations.map(destination => {
        if (destination.id === id) {
          return {
            ...destination,
            operators: [...(destination.operators || []), ...operatorsFormatted]
          }
        }
        return destination
      })
    })
    builder.addCase(removeOperatorFromDestination.fulfilled, (state, action) => {
      const { destinationId, id } = action.payload
      state.destinations = state.destinations.map(destination => {
        if (destination.id === destinationId) {
          return {
            ...destination,
            operators: (destination.operators || []).filter(e => e.id !== id)
          }
        }
        return destination
      })
    })
  }
})

export const destinationsFormattedSelector = (state) => state.destination.destinations

export const destinationOptionsSelector = createDraftSafeSelector(
  destinationsFormattedSelector,
  (state) => state.map(element => ({ label: element.name, value: element.id })),
)

export const { resetDestinationStatus } = destinationSlice.actions;

export default destinationSlice.reducer